import { render, staticRenderFns } from "./payment_status.vue?vue&type=template&id=4ebf7288&scoped=true"
import script from "./payment_status.vue?vue&type=script&lang=js"
export * from "./payment_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf7288",
  null
  
)

export default component.exports